var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PackagingTypesTableAdmin',{attrs:{"countFilterParams":_vm.countFilterParams,"filterGetParams":_vm.filterGetParams,"navTabs":_vm.navTabs},on:{"changeTab":_vm.changeTab,"resetFilter":_vm.resetFilter,"changeFilter":_vm.changeFilter,"showMore":_vm.showMore,"reload":_vm.reload,"reInitTablePage":_vm.initTablePage,"print":_vm.printBarcodes}})
}
var staticRenderFns = []

export { render, staticRenderFns }